<template>
  <div :class="field_container_class">
    <label :class="common_label_class" :for="id">
      {{ label }}<span v-if="required" class="required-indicator">*</span>
    </label>

    <select
      :class="field_class + ' ' + extra_field_class"
      :id="id"
      :type="type"
      placeholder=""
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
    >
      <template v-for="option in options">
        <option :value="option[0]" :key="'select_' + option[0]">{{
          option[1]
        }}</option>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  name: "SimpleTextField.vue",
  props: {
    field_container_class: {
      default: "mb-2 sm:mb-4 md:mb-6 text-left"
    },
    common_label_class: {
      default: "block text-gray-700 text-sm font-bold mb-0 sm:mb-2"
    },
    label: {
      required: true
    },
    id: {
      required: true
    },
    field_class: {
      default:
        "shadow appearance-none border rounded w-full py-1 sm:py-2 px-0 xm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white"
    },
    extra_field_class: {
      default: ""
    },
    value: {},
    options: {},
    type: { default: "text" },
    required: { default: false }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/form/SimpleSelectBox.vue